import "./QualitiesDetails.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";

import { STORE_CONFIG } from "../../Store/ConfigStore";
import {
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_RAW_QUALITIES,
  ROUTE_QUALITIES_DETAILS,
} from "../../routes";
import { STORE_QUALITIES } from "../../Store/QualitiesStore";
import { STORE_AUTH } from "../../Store/AuthStore";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

import XLSX from "xlsx";

import {
  formatDate,
  formatDateOnly,
  fixFloat,
  formatNumber,
} from "../../utility";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import WeighBillButton from "../../Components/WeighBillButton/WeighBillButton";

@inject((stores) => ({
  store: stores.store.get(STORE_QUALITIES),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class WeighBill extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      itemselector: false,
      addressselector: null,
      saving: false,
    };

    props.store.resetWeighBill();
    this.getWeighBill();
  }

  componentDidMount() {
    const { route, store } = this.props;
    if (route.params.hasOwnProperty("editedId")) {
      store.setEditedId(route.params.editedId);
      this.getWeighBill();
    }
  }

  getWeighBill = () => {
    const { store, socket } = this.props;
    if (store.selectedpallets) {
      const _this = this;
      socket.emitWithToken(
        "GetWeighBill",
        { WeighBill: store.selectedWeighBill },
        function (err, data) {
          if (err) {
            console.error(err);
          } else if (data) {
            console.log(data);
            if (data.Error) {
              _this.setState({ popup: "error", popupText: data.Error });
            } else {
              store.setWeighBill(data);
            }
          }
        }
      );
    }
  };

  showPopup = (text) => {
    this.setState({ popup: "result", popupText: text });
  };

  save = () => {
    const { store, socket, authStore } = this.props;
    const { weighbill, weighbilltypes } = store;

    const data = {};

    console.log(data);

    let error = false;
    weighbilltypes.forEach((weighbilltype) => {
      data[weighbilltype.name] =
        weighbill[weighbilltype.name] === "error"
          ? null
          : weighbill[weighbilltype.name] || null;

      let value = data[weighbilltype.name];

      console.log(value);
      switch (weighbilltype.type) {
        case "double":
          if (
            value !== null &&
            value !== undefined &&
            typeof value === "string"
          )
            value = value.replace(",", ".");
          if (
            value !== null &&
            value !== undefined &&
            value !== "" &&
            isNaN(value)
          ) {
            this.showPopup("Nem megfelelő érték: " + weighbilltype.text);
            error = true;
            return;
          }
          break;
        case "int":
          if (
            value !== null &&
            value !== undefined &&
            value !== "" &&
            isNaN(value)
          ) {
            this.showPopup("Nem megfelelő érték: " + weighbilltype.text);
            error = true;
            return;
          }
          break;
      }
    });

    data.User = authStore.user.Id;

    if (error) return;

    const _this = this;
    this.setState({ saving: true });
    socket.emitWithToken("SetWeighBill", data, function (err, data) {
      _this.setState({ saving: false });

      if (err) {
        console.error(err);
        _this.showPopup(err);
      } else {
        _this.showPopup("Sikeres mentés.");
        _this.getWeighBill();
      }
    });
  };

  calc = () => {
    const { store, configStore } = this.props;
    const { weighbill, weighbilltypes } = store;

    const mandatoryfields = [
      "Purity",
      "PurityTreshold",
      //"AlienseedMultiplier",
      "Water",
      "WaterTreshold",
      "Quantity",
    ];

    for (let i = 0; i < mandatoryfields.length; i++) {
      const field = mandatoryfields[i];
      if (!weighbill[field]) {
        this.showPopup(
          "Hiányzó mező: " + weighbilltypes.find((t) => t.name === field).text
        );
      }
    }

    store.normalizeWeighBill();

    let deductionPurity =
      (weighbill.PurityTreshold - weighbill.Purity) *
      weighbill.PurityMultiplier *
      (weighbill.AlienseedMultiplier ? weighbill.AlienseedMultiplier : 1);
    deductionPurity = Math.round(deductionPurity * 100) / 100;
    store.setWeighBillInput("DeductionPurity", Math.max(0, deductionPurity));

    const deductionWater = weighbill.Water - weighbill.WaterTreshold;
    store.setWeighBillInput("DeductionWater", Math.max(0, deductionWater));

    let deductionAllPerc =
      weighbill.DeductionPurity +
      weighbill.DeductionWater +
      weighbill.DeductionGerm;
    deductionAllPerc = Math.round(deductionAllPerc * 100) / 100;
    store.setWeighBillInput("DeductionAllPerc", deductionAllPerc);

    const deductionAllKg =
      weighbill.DeductionAllPerc * 0.01 * weighbill.Quantity;
    store.setWeighBillInput("DeductionAllKg", Math.round(deductionAllKg));

    const _yield = weighbill.DeductionAll
      ? weighbill.Quantity - weighbill.DeductionAll
      : weighbill.Quantity - weighbill.DeductionAllKg;
    store.setWeighBillInput("Yield", _yield);
  };

  back = () => {
    const { store, router } = this.props;
    store.resetQualities();
    store.setSelectedPallets([]);
    let route = "";
    switch (store.type) {
      case "processed":
        route = ROUTE_PROCESSED_QUALITIES;
        break;
      case "raw":
        route = ROUTE_RAW_QUALITIES;
        break;
    }
    router.navigate(route, { back: true });
  };

  handleDownload() {
    const { configStore, store } = this.props;
    const { mergeditems, task } = store;

    const merges = [];
    const data = [
      ["Rendelési azonosító", task.orderid],
      [],
      ["Cikkszám", "Cikknév", "Sarzs", "Szavidő", "Mennyiség", "Összekészítve"],
    ];
    let rowindex = 4;

    for (let i = 0; i < mergeditems.length; i++) {
      const mergeditem = mergeditems[i];
      const item = configStore.items[mergeditem.id] || {};

      console.log(mergeditem);

      data.push([
        item.Name,
        item.CodeManufacturer,
        mergeditem.sarzs || "",
        mergeditem.expiration || "",
        (mergeditem.quantity || 0) + " " + item.Unit,
        (mergeditem.picked || 0) + " " + item.Unit,
      ]);
    }

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "BL-" + task.id);

    XLSX.writeFile(wb, "BL-" + task.id + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  }

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { weighbill } = store;
    console.log(weighbill);
    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table__top-backpanel">
              <Button className="task__editbutton" onClick={() => this.back()}>
                Vissza
              </Button>
              <div className="table__top-pagename">
                {(store.type === "raw" ? "Nyers" : "Feldolgozott") +
                  " áru minőség részletek"}
              </div>
            </div>

            <div className="table__top-backpanel">
              {weighbill.Yield && (
                <WeighBillButton id={weighbill.Id} lang="hu" />
              )}
              {weighbill.Yield && (
                <WeighBillButton id={weighbill.Id} lang="slo" />
              )}
              {configStore.weighbillTresholds[weighbill.Item] && (
                <Button
                  className="task__editbutton"
                  disabled={this.state.saving}
                  onClick={() => this.calc()}
                >
                  Számol
                </Button>
              )}

              <Button
                className="task__editbutton"
                disabled={this.state.saving}
                onClick={() => this.save()}
              >
                Mentés
              </Button>
            </div>
          </div>
          <div className="masterdata_form_frame">
            <div className="masterdata_form wrapped">
              {store.weighbilltypes.map((weighbilltype) => {
                if (weighbilltype.hidden) return null;
                return (
                  <div key={weighbilltype.name} className="formfield wrapped">
                    <div className="formfield_label">
                      {weighbilltype.text}
                      {weighbill[weighbilltype.name] === "error" && (
                        <div className="formfield_label-error">
                          (eltérő adatok)
                        </div>
                      )}
                    </div>
                    <div className="formfield_input">
                      {weighbilltype.editable ? (
                        <input
                          className="edit-input"
                          value={
                            weighbill[weighbilltype.name] !== "error"
                              ? weighbill[weighbilltype.name]
                              : null
                          }
                          onChange={(e) =>
                            store.setWeighBillInput(
                              [weighbilltype.name],
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        <span className="formfield_input-label">
                          {weighbill[weighbilltype.name] !== "error"
                            ? weighbill[weighbilltype.name]
                            : null}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {(this.state.popup === "error" || this.state.popup === "result") && (
          <Popup
            key="popup"
            text={this.state.popupText}
            buttons={[
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                  if (this.state.popup === "error") this.back();
                }}
              >
                Ok
              </Button>,
            ]}
            onClickClose={() => {
              this.setState({ popup: "none" });
              if (this.state.popup === "error") this.back();
            }}
          />
        )}
        {this.state.popup === "delete" && (
          <Popup
            key="popup"
            text="Biztosan törli?"
            buttons={[
              <Button
                className="popup_button"
                onClick={() => {
                  this.setState({ popup: "none" });
                  this.delete();
                }}
              >
                Igen
              </Button>,
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                }}
              >
                Mégse
              </Button>,
            ]}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_QUALITIES_DETAILS}>
    {(routeProps) => <WeighBill {...routeProps} {...props} />}
  </RouteNode>
);
